module.exports = __webpack_public_path__ + "img/reya.e88c1488.jpeg";